<div class="modal-overlay" *ngIf="lead" (click)="closePanel.emit()">
    <div class="modal-card modal-card--full" (click)="$event.stopPropagation()">
        <!-- Header with Avatar and Profile -->
        <div class="modal-header modal-header--profile">
            <div class="profile-header">
                <div class="avatar" [style.background-color]="avatarColor">
                    <img *ngIf="avatarUrl" [src]="avatarUrl" (error)="onAvatarError()" alt="Profile" />
                    <span *ngIf="!avatarUrl" class="avatar-initials">{{ initials }}</span>
                </div>
                <div class="profile-info">
                    <h2 class="profile-name">
                        {{ lead.firstName || 'No Name' }} {{ lead.lastName }}
                        <span *ngIf="lead.isManualLead" class="manual-lead-tag"><i class="fa-solid fa-hand"></i> Manual</span>
                    </h2>
                    <span class="profile-company" *ngIf="lead.companyName">{{ lead.companyName }}</span>
                    <div class="profile-contact-row">
                        <span *ngIf="lead.email" class="contact-chip" (click)="emailClicked.emit(lead.email)">
                            <i class="fa-solid fa-envelope"></i> {{ lead.email }}
                        </span>
                        <span *ngIf="lead.phoneNumber" class="contact-chip" (click)="phoneClicked.emit(lead.phoneNumber)">
                            <i class="fa-solid fa-phone"></i> {{ lead.phoneNumber }}
                        </span>
                    </div>
                </div>
                <div class="header-right">
                    <div class="header-actions">
                        <button class="action-pill" *ngIf="lead.email" (click)="emailClicked.emit(lead.email)"><i class="fa-solid fa-envelope"></i> Email</button>
                        <button class="action-pill action-pill--call" *ngIf="lead.phoneNumber" (click)="phoneClicked.emit(lead.phoneNumber)"><i class="fa-solid fa-phone"></i> Call</button>
                        <button class="action-pill action-pill--whatsapp" *ngIf="lead.phoneNumber" (click)="whatsappClicked.emit(lead.phoneNumber)">
                            <i class="fa-brands fa-whatsapp"></i> WhatsApp
                        </button>
                        <a class="action-pill action-pill--view" [routerLink]="['/client/', lead.$key]" (click)="closePanel.emit()"><i class="fa-solid fa-external-link"></i> Profile</a>
                        <a class="action-pill" [routerLink]="['/admin/subscriptions/create-on-behalf/', lead.$key]" (click)="closePanel.emit()"><i class="fa-solid fa-credit-card"></i> Create Subscription</a>
                        <button class="action-pill action-pill--star" [class.starred]="lead.isStarred" (click)="starToggled.emit(lead)">
                            <i [class]="lead.isStarred ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                        </button>
                    </div>
                </div>
            </div>
            <button class="modal-close" (click)="closePanel.emit()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="modal-body lead-detail-body">
            <!-- Lead Management Bar -->
            <div class="lead-management-bar">
                <div class="management-field management-field--highlight">
                    <label>Assigned To</label>
                    <select [ngModel]="lead.userResponsible" (ngModelChange)="userResponsibleUpdated.emit($event)">
                        <option *ngIf="!isSalesManagerMode" value="">Select</option>
                        <option *ngFor="let assignee of crmAssignees" [value]="assignee.$key">{{ assignee.displayName }}</option>
                    </select>
                </div>
                <div class="management-field">
                    <label>Type</label>
                    <select [ngModel]="lead.contactType || 'User'" (ngModelChange)="fieldUpdated.emit({field: 'contactType', value: $event})">
                        <option *ngFor="let type of contactTypes" [value]="type">{{ type }}</option>
                    </select>
                </div>
                <div class="management-field">
                    <label>Status</label>
                    <select [ngModel]="lead.leadStatus" (ngModelChange)="fieldUpdated.emit({field: 'leadStatus', value: $event})">
                        <option value="">Select</option>
                        <option *ngFor="let status of leadStatuses" [value]="status">{{ status }}</option>
                    </select>
                </div>
                <div class="management-field">
                    <label>Bays</label>
                    <input type="number" [ngModel]="lead.numberOfBays" (ngModelChange)="fieldUpdated.emit({field: 'numberOfBays', value: $event})" placeholder="0" />
                </div>
                <div class="management-field">
                    <label>Months</label>
                    <input type="number" [ngModel]="lead.monthsRequired" (ngModelChange)="fieldUpdated.emit({field: 'monthsRequired', value: $event})" placeholder="0" />
                </div>
                <div class="management-field">
                    <label>Location</label>
                    <select [ngModel]="lead.broadLocation" (ngModelChange)="fieldUpdated.emit({field: 'broadLocation', value: $event})">
                        <option value="">Select</option>
                        <option *ngFor="let loc of broadLocations" [value]="loc">{{ loc }}</option>
                    </select>
                </div>
                <div class="management-field management-field--wide">
                    <label>Address</label>
                    <input
                        type="text"
                        appAddressAutocomplete
                        [value]="lead.fullAddress || ''"
                        (input)="onAddressInput($any($event.target).value)"
                        (placeSelected)="addressUpdated.emit($event)"
                        placeholder="Start typing an address..."
                    />
                    <p class="geocode-hint" *ngIf="lead.latitude && lead.longitude">
                        <i class="fa-solid fa-map-pin"></i> {{ lead.latitude | number: '1.4-4' }}, {{ lead.longitude | number: '1.4-4' }}
                    </p>
                </div>
                <div class="management-field" *ngIf="lead.leadStatus === LeadStatus.CLOSED">
                    <label>Closed Reason</label>
                    <select [ngModel]="lead.leadClosedReason" (ngModelChange)="fieldUpdated.emit({field: 'leadClosedReason', value: $event})">
                        <option value="">Select</option>
                        <option *ngFor="let reason of leadClosedReasons" [value]="reason">{{ reason }}</option>
                    </select>
                </div>
            </div>

            <!-- Tags Bar -->
            <div class="tags-bar">
                <span class="tags-label"><i class="fa-solid fa-tags"></i> Tags</span>
                <div class="tags-list">
                    <span class="tag-chip" *ngFor="let tag of getLeadTags()">
                        {{ tag }}
                        <button class="tag-remove" (click)="tagRemoved.emit(tag)"><i class="fa-solid fa-xmark"></i></button>
                    </span>
                    <button class="tag-add-btn" (click)="createTagRequested.emit()">
                        <i class="fa-solid fa-plus"></i> Add Tag
                    </button>
                </div>
            </div>

            <!-- Two-column layout: Tabs + Comments sidebar -->
            <div class="modal-body-layout">
                <!-- Main content with tabs -->
                <div class="modal-main-content">
                    <!-- Tabs -->
                    <div class="detail-tabs">
                        <button class="detail-tab" [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">
                            <i class="fa-solid fa-user"></i> Overview
                        </button>
                        <button class="detail-tab" [class.active]="activeTab === 'subscriptions'" (click)="activeTab = 'subscriptions'">
                            <i class="fa-solid fa-file-contract"></i> Subscriptions
                            <span class="tab-count" *ngIf="getSubscriptionSummaries().length">{{ getSubscriptionSummaries().length }}</span>
                        </button>
                        <button class="detail-tab" [class.active]="activeTab === 'details'" (click)="activeTab = 'details'">
                            <i class="fa-solid fa-circle-info"></i> Details
                        </button>
                        <button class="detail-tab" [class.active]="activeTab === 'sendMessage'" (click)="activeTab = 'sendMessage'">
                            <i class="fa-brands fa-whatsapp"></i> Send Message
                        </button>
                    </div>

                    <!-- Overview Tab -->
                    <div *ngIf="activeTab === 'overview'">
                        <div class="lead-columns">
                            <div class="lead-column">
                                <div class="lead-section">
                                    <h3>Subscription Status</h3>
                                    <div class="status-badges">
                                        <div class="status-badge" [class.active]="hasEverParked()">
                                            <i class="fa-solid" [class.fa-check]="hasEverParked()" [class.fa-xmark]="!hasEverParked()"></i>
                                            Ever Parked
                                        </div>
                                        <div class="status-badge" [class.active]="hasActiveSub()">
                                            <i class="fa-solid" [class.fa-check]="hasActiveSub()" [class.fa-xmark]="!hasActiveSub()"></i>
                                            Active Sub
                                        </div>
                                        <div class="status-badge" [class.active]="hasFutureSub()">
                                            <i class="fa-solid" [class.fa-check]="hasFutureSub()" [class.fa-xmark]="!hasFutureSub()"></i>
                                            Future Sub
                                        </div>
                                    </div>
                                    <div class="sub-stats">
                                        <div class="sub-stat">
                                            <span class="stat-value">{{ getCompletedCount() }}</span>
                                            <span class="stat-label">Completed</span>
                                        </div>
                                        <div class="sub-stat sub-stat--warning">
                                            <span class="stat-value">{{ getBreachedCount() }}</span>
                                            <span class="stat-label">Breached</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="lead-column">
                                <div class="lead-section">
                                    <h3>Campaign Attribution</h3>
                                    <div class="lead-info-grid lead-info-grid--compact">
                                        <div class="info-item">
                                            <span class="info-label">Source</span>
                                            <span class="info-value">
                                                <span *ngIf="lead.p_source" class="source-badge">{{ lead.p_source }}</span>
                                                <span *ngIf="!lead.p_source">-</span>
                                            </span>
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Campaign</span>
                                            <span class="info-value">{{ lead.p_campaign || '-' }}</span>
                                        </div>
                                        <div class="info-item">
                                            <span class="info-label">Enterprise</span>
                                            <span class="info-value">
                                                <span *ngIf="lead.denormEnterpriseKey" class="badge badge--info text-capitalize">{{ lead.denormEnterpriseKey }}</span>
                                                <span *ngIf="!lead.denormEnterpriseKey">-</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Subscriptions Tab -->
                    <div *ngIf="activeTab === 'subscriptions'" class="lead-section">
                        <div *ngIf="getSubscriptionSummaries().length === 0" class="subscriptions-empty">
                            <i class="fa-solid fa-file-contract"></i>
                            <p>No subscriptions found</p>
                        </div>
                        <table *ngIf="getSubscriptionSummaries().length > 0" class="subscriptions-table">
                            <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Period</th>
                                    <th>Bays</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let sub of getSubscriptionSummaries()">
                                    <td><span class="sub-status-badge" [ngClass]="getStatusClass(sub.status)">{{ sub.status }}</span></td>
                                    <td>{{ sub.startDate | date: 'mediumDate' }}</td>
                                    <td>{{ sub.endDate | date: 'mediumDate' }}</td>
                                    <td>{{ sub.period }} {{ sub.period === 1 ? 'month' : 'months' }}</td>
                                    <td>{{ sub.baysBooked }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Details Tab -->
                    <div *ngIf="activeTab === 'details'">
                        <div class="lead-section">
                            <h3>Contact Information</h3>
                            <div class="lead-info-grid lead-info-grid--compact">
                                <div class="info-item">
                                    <span class="info-label">Email</span>
                                    <span class="info-value">{{ lead.email || '-' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Phone</span>
                                    <span class="info-value">{{ lead.phoneNumber || '-' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Created</span>
                                    <span class="info-value">{{ lead.createdAt?.toDate() | date: 'mediumDate' }} ({{ daysSinceCreated }}d ago)</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Contact Type</span>
                                    <span class="info-value">{{ lead.contactType || 'User' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Send Message Tab -->
                    <div *ngIf="activeTab === 'sendMessage'">
                        <div class="lead-section">
                            <h3>Send WhatsApp Template</h3>
                            <div class="send-template-bar">
                                <div class="send-template-row">
                                    <div class="send-template-field">
                                        <label>Template</label>
                                        <select [(ngModel)]="selectedTemplate" (ngModelChange)="onTemplateChange()">
                                            <option value="">Select a template...</option>
                                            <option *ngFor="let tpl of crmWhatsappTemplates" [value]="tpl.value">{{ tpl.label }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="send-template-params" *ngIf="selectedTemplateParams.length">
                                    <div class="send-template-field" *ngFor="let param of selectedTemplateParams">
                                        <label>{{ param.label }}</label>
                                        <input
                                            [type]="param.type"
                                            [(ngModel)]="templateParamValues[param.name]"
                                            [placeholder]="param.label"
                                        />
                                    </div>
                                </div>
                                <div class="send-template-row">
                                    <button class="btn btn-send-template" [disabled]="!canSendTemplate" (click)="emitSendTemplate()">
                                        <i class="fa-brands fa-whatsapp"></i>
                                        <span>Send</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Comments Sidebar (always visible) -->
                <div class="modal-sidebar" *ngIf="lead.$key">
                    <div class="sidebar-header">
                        <i class="fa-solid fa-comments"></i>
                        <span>Comments</span>
                        <span class="sidebar-count" *ngIf="lead.commentsCount">{{ lead.commentsCount }}</span>
                    </div>
                    <div class="sidebar-body">
                        <app-comments [adminClientKey]="lead.$key!"></app-comments>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
